import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useCourtyard } from "@/context/CourtyardContext";

export default function StickyRsvp() {
  const { rsvp, openRsvp, rsvpOpen } = useCourtyard();
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const band = document.getElementById("rsvp")?.getBoundingClientRect();
      const nearBand = band && band.top < window.innerHeight && band.bottom > 0;
      const nearEnd = window.innerHeight + window.scrollY > document.body.scrollHeight - 120;
      setShow(window.scrollY > window.innerHeight * 0.9 && !nearBand && !nearEnd);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <AnimatePresence>
      {show && !rsvpOpen && (
        <motion.div
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed inset-x-3 bottom-3 z-40 md:hidden"
          style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
        >
          <button type="button" onClick={openRsvp} className="btn-primary w-full shadow-lg" data-testid="sticky-rsvp-button">
            {rsvp ? "Update my RSVP" : "RSVP in 30 seconds"}
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
